export default __webpack_public_path__ + "static/media/Monger-HUD-06.a3b30578.jpg";